// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.more-menu-container[data-v-7606cc88] {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
